module.exports = __webpack_public_path__ + "static/img/4_1.d847a6cc.jpg";